import React from 'react';

export default function Contact() {
  return (
    <>
      <div className="container">
        <h1>Privacy and Policy</h1>
      </div>
    </>
  );
}
